/** Saves rows as a CSV file (with a BOM, so Excel reads the Arabic). */
export function downloadCsv(name: string, rows: string[][]) {
  const cell = (c: string) => (/[",\n]/.test(c) ? `"${c.replaceAll('"', '""')}"` : c);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob(["﻿" + rows.map((r) => r.map(cell).join(",")).join("\n")], { type: "text/csv;charset=utf-8" }));
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
